import { datadogRum } from '@datadog/browser-rum';
import { useCallback } from 'react';

/**
 * Sends a RUM custom action to datadog when the returned function is called, including:
 * - `message` as the action name
 * - duration of the execution
 * - execution context (params function is called with)
 * @param fn The function to wrap
 * @param message The action name to send to datadog
 * @returns A wrapper of the param function
 */
export const useWithDurationLog = <Params extends Array<unknown>, Return>(
  fn: (...params: Params) => Return,
  message: string
) => {
  const cb = useCallback(
    async (...params: Params) => {
      const startTime = Date.now();
      try {
        return await fn(...params);
      } finally {
        datadogRum.addAction(message, {
          duration: Date.now() - startTime,
          context: params,
        });
      }
    },
    [fn, message]
  );
  return cb;
};
